<template>
	<div class="app-icon" v-on="$listeners">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			:viewBox="icon.viewBox"
			:aria-labelledby="iconName"
			role="presentation"
		>
			<title
				:id="iconName"
				lang="en"
			>
				{{ iconName }} icon
			</title>

			<g :fill="iconColor">
				<slot>
					<path
						v-if="iconName"
						:d="icon.d"
						:transform="icon.transform"
					/>
				</slot>
			</g>
		</svg>
	</div>
</template>

<script>
const icons = {
	dashboard: {
		d: 'M10.353,10.4c-.585,0-1.059.313-1.059.7v4.2c0,.387.474.7,1.059.7s1.059-.313,1.059-.7V11.1C11.412,10.713,10.938,10.4,10.353,10.4ZM5.059,13.2c-.585,0-1.059.313-1.059.7v1.4c0,.387.474.7,1.059.7s1.059-.313,1.059-.7V13.9C6.118,13.513,5.644,13.2,5.059,13.2ZM20.941,2c-.585,0-1.059.313-1.059.7V15.3c0,.387.474.7,1.059.7S22,15.687,22,15.3V2.7C22,2.313,21.526,2,20.941,2ZM15.647,6.9c-.585,0-1.059.313-1.059.7v7.7c0,.387.474.7,1.059.7s1.059-.313,1.059-.7V7.6C16.706,7.213,16.232,6.9,15.647,6.9Z',
		transform: 'translate(-4 -2)',
		viewBox: '0 0 18 14'
	},

	session: {
		d: 'M7.14,3.729a.682.682,0,1,0,.682.682A.682.682,0,0,0,7.14,3.729Zm-2.729,0a.682.682,0,1,0,.682.682A.682.682,0,0,0,4.411,3.729Zm5.458,0a.682.682,0,1,0,.682.682A.682.682,0,0,0,9.869,3.729ZM13.962,1H3.047A2.047,2.047,0,0,0,1,3.047V13.962a2.047,2.047,0,0,0,2.047,2.047H13.962a2.047,2.047,0,0,0,2.047-2.047V3.047A2.047,2.047,0,0,0,13.962,1Zm.682,12.962a.682.682,0,0,1-.682.682H3.047a.682.682,0,0,1-.682-.682V7.822h12.28Zm0-7.5H2.364V3.047a.682.682,0,0,1,.682-.682H13.962a.682.682,0,0,1,.682.682Z',
		transform: 'translate(-1 -1)',
		viewBox: '0 0 15.008 15.008'
	},

	router: {
		d: 'M7.311,14.416a.828.828,0,1,0,.828.828A.828.828,0,0,0,7.311,14.416Zm0-4.966a.828.828,0,1,0,.828.828A.828.828,0,0,0,7.311,9.45Zm0-4.966a.828.828,0,1,0,.828.828A.828.828,0,0,0,7.311,4.483Zm9.933,0A2.483,2.483,0,0,0,14.761,2H6.483A2.483,2.483,0,0,0,4,4.483V6.139a2.483,2.483,0,0,0,.646,1.655A2.483,2.483,0,0,0,4,9.45v1.655a2.483,2.483,0,0,0,.646,1.655A2.483,2.483,0,0,0,4,14.416v1.655a2.483,2.483,0,0,0,2.483,2.483h8.277a2.483,2.483,0,0,0,2.483-2.483V14.416a2.483,2.483,0,0,0-.646-1.655,2.483,2.483,0,0,0,.646-1.655V9.45A2.483,2.483,0,0,0,16.6,7.794a2.483,2.483,0,0,0,.646-1.655ZM15.588,16.072a.828.828,0,0,1-.828.828H6.483a.828.828,0,0,1-.828-.828V14.416a.828.828,0,0,1,.828-.828h8.277a.828.828,0,0,1,.828.828Zm0-4.966a.828.828,0,0,1-.828.828H6.483a.828.828,0,0,1-.828-.828V9.45a.828.828,0,0,1,.828-.828h8.277a.828.828,0,0,1,.828.828Zm0-4.966a.828.828,0,0,1-.828.828H6.483a.828.828,0,0,1-.828-.828V4.483a.828.828,0,0,1,.828-.828h8.277a.828.828,0,0,1,.828.828Z',
		transform: 'translate(-4 -2)',
		viewBox: '0 0 13.244 16.555'
	},

	user: {
		d: 'M13.529,11.252a3.357,3.357,0,0,0,.9-2.25,3.4,3.4,0,1,0-6.8,0,3.357,3.357,0,0,0,.9,2.25A5.346,5.346,0,0,0,5.6,15.4a.905.905,0,1,0,1.8.2,3.6,3.6,0,0,1,7.146,0,.9.9,0,0,0,.954.8h.1a.9.9,0,0,0,.792-.99,5.346,5.346,0,0,0-2.862-4.158ZM11,10.6A1.6,1.6,0,1,1,12.6,9,1.6,1.6,0,0,1,11,10.6ZM17.3,2H4.7A2.7,2.7,0,0,0,2,4.7V17.3A2.7,2.7,0,0,0,4.7,20H17.3A2.7,2.7,0,0,0,20,17.3V4.7A2.7,2.7,0,0,0,17.3,2Zm.9,15.3a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V4.7a.9.9,0,0,1,.9-.9H17.3a.9.9,0,0,1,.9.9Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 18 18'
	},

	order: {
		d: 'M19.074,14.581H6.493a.9.9,0,0,1,0-1.8h9.382a2.7,2.7,0,0,0,2.615-2.04l1.483-5.832a.893.893,0,0,0-.9-1.114H6.277A2.7,2.7,0,0,0,3.743,2H2.9a.9.9,0,0,0,0,1.8h.845a.9.9,0,0,1,.9.683l.054.431h0L6.25,10.986a2.7,2.7,0,0,0,.243,5.392h.162a2.7,2.7,0,1,0,5.068,0h2.121a2.7,2.7,0,1,0,5.068,0h.162a.9.9,0,1,0,0-1.8Zm-1.15-8.986L16.746,10.3a.9.9,0,0,1-.9.683H8.093L6.745,5.594ZM9.189,18.175a.9.9,0,1,1,.9-.9A.9.9,0,0,1,9.189,18.175Zm7.189,0a.9.9,0,1,1,.9-.9A.9.9,0,0,1,16.378,18.175Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 18 17.994'
	},

	notification: {
		d: 'M19.75,14.578V11a6.75,6.75,0,0,0-5.625-6.649V3.125a1.125,1.125,0,1,0-2.25,0V4.351A6.75,6.75,0,0,0,6.25,11v3.577A3.375,3.375,0,0,0,4,17.75V20a1.125,1.125,0,0,0,1.125,1.125H8.658a4.5,4.5,0,0,0,8.685,0h3.533A1.125,1.125,0,0,0,22,20V17.75a3.375,3.375,0,0,0-2.25-3.172ZM8.5,11a4.5,4.5,0,1,1,9,0v3.375h-9ZM13,22.25a2.25,2.25,0,0,1-1.935-1.125h3.87A2.25,2.25,0,0,1,13,22.25Zm6.75-3.375H6.25V17.75a1.125,1.125,0,0,1,1.125-1.125h11.25A1.125,1.125,0,0,1,19.75,17.75Z',
		transform: 'translate(-4 -2)',
		viewBox: '0 0 18 22.445'
	},

	search: {
		d: 'm44.498 44.415c-1.6691 1.6691-4.3745 1.6691-6.0438 0l-7.5415-7.5416c-3.1005 1.989-6.7655 3.1741-10.723 3.1741-11.012 0-19.941-8.9273-19.941-19.941s8.9285-19.941 19.941-19.941c11.014 0 19.941 8.927 19.941 19.941 0 3.9559-1.1866 7.6223-3.1742 10.724l7.5416 7.5416c1.6691 1.6691 1.6691 4.3731 0 6.0422zm-24.308-38.551c-7.8658 0-14.243 6.376-14.243 14.243s6.3775 14.243 14.243 14.243c7.8671 0 14.243-6.3761 14.243-14.243s-6.3761-14.243-14.243-14.243z',
		viewBox: '0 0 46 46'
	},

	check: {
		d: 'M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,1.41,0l5-5a1,1,0,1,0-1.41-1.42Z',
		transform: 'translate(-7.02 -8.499)',
		viewBox: '0 0 9.405 7.001'
	},

	calendar: {
		d: 'M9.5,14.5a.75.75,0,1,0-.75-.75A.75.75,0,0,0,9.5,14.5Zm3.75,0a.75.75,0,1,0-.75-.75A.75.75,0,0,0,13.25,14.5Zm0-3a.75.75,0,1,0-.75-.75A.75.75,0,0,0,13.25,11.5Zm-3.75,0a.75.75,0,1,0-.75-.75A.75.75,0,0,0,9.5,11.5Zm5.25-9H14V1.75a.75.75,0,1,0-1.5,0V2.5h-6V1.75a.75.75,0,0,0-1.5,0V2.5H4.25A2.25,2.25,0,0,0,2,4.75v10.5A2.25,2.25,0,0,0,4.25,17.5h10.5A2.25,2.25,0,0,0,17,15.25V4.75A2.25,2.25,0,0,0,14.75,2.5Zm.75,12.75a.75.75,0,0,1-.75.75H4.25a.75.75,0,0,1-.75-.75V8.5h12ZM15.5,7H3.5V4.75A.75.75,0,0,1,4.25,4H5v.75a.75.75,0,1,0,1.5,0V4h6v.75a.75.75,0,1,0,1.5,0V4h.75a.75.75,0,0,1,.75.75ZM5.75,11.5A.75.75,0,1,0,5,10.75.75.75,0,0,0,5.75,11.5Zm0,3A.75.75,0,1,0,5,13.75.75.75,0,0,0,5.75,14.5Z',
		transform: 'translate(-2 -1)',
		viewBox: '0 0 15 16.5'
	},

	clock: {
		d: 'M8.5,2A7.5,7.5,0,1,0,16,9.5,7.5,7.5,0,0,0,8.5,2Zm0,13.5a6,6,0,1,1,6-6A6,6,0,0,1,8.5,15.5ZM8.5,5a.75.75,0,0,0-.75.75v3H6.25a.75.75,0,1,0,0,1.5H8.5a.75.75,0,0,0,.75-.75V5.75A.75.75,0,0,0,8.5,5Z',
		transform: 'translate(-1 -2)',
		viewBox: '0 0 15 15'
	},

	arrowLeft: {
		d: 'M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1.034,1.034,0,0,0,0,1.42l5,5a1,1,0,1,0,1.42-1.42L9.41,13H17a1,1,0,0,0,0-2Z',
		transform: 'translate(-6.005 -5.996)',
		viewBox: '0 0 11.995 12.01'
	},

	edit: {
		d: 'M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z',
		viewBox: '0 0 20 20.006',
		transform: 'translate(-2 -1.994)'
	},

	delete: {
		d: 'M16.6,5.2H13.4V4.4A2.4,2.4,0,0,0,11,2H9.4A2.4,2.4,0,0,0,7,4.4v.8H3.8a.8.8,0,1,0,0,1.6h.8v8.8A2.4,2.4,0,0,0,7,18h6.4a2.4,2.4,0,0,0,2.4-2.4V6.8h.8a.8.8,0,1,0,0-1.6Zm-8-.8a.8.8,0,0,1,.8-.8H11a.8.8,0,0,1,.8.8v.8H8.6Zm5.6,11.2a.8.8,0,0,1-.8.8H7a.8.8,0,0,1-.8-.8V6.8h8Z',
		viewBox: '0 0 14.4 16',
		transform: 'translate(-3 -2)'
	},

	chevron: {
		d: 'M12.524,14.679l5.348-5.348A1.512,1.512,0,1,0,15.727,7.2L9.321,13.607a1.511,1.511,0,0,0,0,2.145l6.406,6.481a1.512,1.512,0,0,0,2.145-2.13Z',
		viewBox: '0 0 9.437 15.917',
		transform: 'translate(-8.874 -6.754)'
	},

	file: {
		d: 'M9,10h1a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Zm0,2a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM20,8.94a1.31,1.31,0,0,0-.06-.27V8.58a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,13.05,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V8.94ZM14,5.41,16.59,8H15a1,1,0,0,1-1-1ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V7a3,3,0,0,0,3,3h3Zm-3-3H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z',
		viewBox: '0 0 16 20',
		transform: 'translate(-4 -2)'
	},

	copy: {
		d: 'M16,20H8a3,3,0,0,1-3-3V7A1,1,0,1,0,3,7V17a5,5,0,0,0,5,5h8a1,1,0,0,0,0-2ZM21,8.94a1.31,1.31,0,0,0-.06-.27V8.58a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19h-.09L14.06,2H10A3,3,0,0,0,7,5V15a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8.94ZM15,5.41,17.59,8H16a1,1,0,0,1-1-1ZM19,15a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V5a1,1,0,0,1,1-1h3V7a3,3,0,0,0,3,3h3Z',
		viewBox: '0 0 18 20',
		transform: 'translate(-3 -2)'
	},

	expand: {
		viewBox: '0 0 20 20',
		d: 'M11,12H3a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V13A1,1,0,0,0,11,12Zm-1,8H4V14h6ZM21.92,2.62A1.015,1.015,0,0,0,21,2H15a1,1,0,0,0,0,2h3.59l-5.3,5.29a1,1,0,1,0,1.42,1.42L20,5.41V9a1,1,0,0,0,2,0V3a1,1,0,0,0-.08-.38Z',
		transform: 'translate(-2 -2)'
	}
}

export default {
	props: {
		iconName: {
			type: String,
			default: ''
		},

		iconColor: {
			type: String,
			default: 'currentColor'
		}
	},

	computed: {
		icon () {
			return icons[this.iconName]
		}
	}
}
</script>

<style lang="scss" scoped>
.app-icon {
	display: inline-block;

	svg {
		width: 100%;
		height: 100%;
		pointer-events: none;
	}
}
</style>
